// extracted by mini-css-extract-plugin
export default {"divBotaoSalvar":"stylesCadastroUsuarios_divBotaoSalvar__MeY25","botaoSalvar":"stylesCadastroUsuarios_botaoSalvar__H0F3e"};